import * as React from 'react';
import * as UI from 'core/ui';

import { Res } from 'core/api';
import { ActionButtonDefinition, DialogIcon, PosScreenClassComponent } from 'pos/ui';
import * as Images from 'pos/Images';
import { Modal } from 'core/ui-next/modal';


type State = {
	TipAmount: Nullable<number>
}


export default class InsertCustomTipAmountScreen extends PosScreenClassComponent<Modal.Actions<number>, State> {

	createInitialState(_props: Modal.Actions<number>): Nullable<State> {
		return { TipAmount: null };
	}

	protected form = React.createRef<UI.Form<State>>();

	protected getScreenId(): string {
		return 'SELECT_CUSTOM_TIP_AMOUNT';
	}

	protected getTitle(): string {
		return Res.Web.SELECT_SUGGESTED_TIP_TITLE();
	}

	protected getImage(): string | SvgIcon {
		return Images.TipSettings;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			{ title: Res.Common.OK_BTN(), image: Images.Ok, action: this.processTip },
		];
	}

	protected useKeypad(): boolean {
		return true;
	}

	protected getScreenSize(): UI.ScreenSize {
		return { width: 400, height: 700 };
	}

	processTip = async (): Promise<void> => {
		const ok = await this.form.current?.updateModel();
		if (!ok)
			return;

		this.close(this.state.TipAmount!);
	};


	getContent(): React.ReactNode {
		const { Form, PriceBox } = UI.controlsFor<State>();
		return <Form small ref={this.form} model={this.state}>
			<DialogIcon src={this.getImage()} />
			<UI.Cols>
				<UI.Col width='*'>
					<PriceBox
						linkTo={x => x.TipAmount}
						allowNegative={false}
						className='text-center'
						childrenPosition='prepend'
						rules={[UI.Constraints.maxDecimalPlaces(2), UI.Constraints.maxLength(10)]}
						placeholder={Res.Web.SELECT_CUSTOM_TIP_PLACEHOLDER()}
						required>
					</PriceBox>
				</UI.Col>
			</UI.Cols>
		</Form>;
	}
	onComponentDidMount(): void { }

	onComponentWillUnmount(): void { }
}

